import type { RealtimeHandler } from "@/shared/realtime";

import {
  ANALYSIS_HIGHLIGHTS_QUERY_KEY,
  HIGHLIGHTS_OVERVIEW_QUERY_KEY,
} from "../api/HIGHLIGHTS_QUERY_KEYS";

// `highlights.updated` → моменты матча игрока найдены или клип сменил статус: перечитываются
// хайлайты разборов (событие приходит по матчу, а кэш — по разбору, поэтому все сразу)
// и раздел «Хайлайты». Повтор события — ещё одна инвалидация.
export const handleHighlightsUpdated: RealtimeHandler<"highlights.updated"> = (
  _event,
  { queryClient },
) => {
  void queryClient.invalidateQueries({ queryKey: ANALYSIS_HIGHLIGHTS_QUERY_KEY });
  void queryClient.invalidateQueries({ queryKey: HIGHLIGHTS_OVERVIEW_QUERY_KEY });
};
